// extracted by mini-css-extract-plugin
export var container = "styles-module__container___wKw9v";
export var contentContainer = "styles-module__contentContainer___DSwb_";
export var image = "styles-module__image___inJo5";
export var content = "styles-module__content___RK1eC";
export var favorite = "styles-module__favorite___Cy4q7";
export var add = "styles-module__add___eRj7P";
export var badge = "styles-module__badge___pRsV8";
export var fullWidth = "styles-module__fullWidth___o4cRr";
export var userImage = "styles-module__userImage___k4B8r";
export var bottomButtons = "styles-module__bottomButtons___InFPg";